import { ChangeEvent, useState, useEffect } from "react";
import {
  Divider,
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableContainer,
  CardHeader,
  CardContent,
  Container,
  Grid,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { HttpClient } from "src/Helpers/http/http";
import { debounce } from "lodash";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import { ITraineeAccountType } from "../types/TraineeAccountTypes";
import { DatePicker } from "@mui/x-date-pickers";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import CreateTraineeAccount from "../components/CreateTraineeAccount";
import TraineeAccountTableRow from "../components/TraineeAccountTableRow";

const TraineeAccountList = () => {
  const [limit, setLimit] = useState<number>(25);
  const [total, setTotal] = useState<number>(0);
  const [openManual, setOpenManual] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [allAccount, setAllAccount] = useState<ITraineeAccountType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [_searchInvoiceVal, _setSearchInvoiceVal] = useState<string>("");
  // const searchQuery = useDebounce(searchInvoiceVal, 1000);
  const [refresh, setRefresh] = useState(false);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [filterItem, setFilterItem] = useState({
    receipt_no: "",
    company_name: "",
  });
  const [searchParams, setSearchParams] = useSearchParams({
    page: "0",
  });

  const page = parseInt(searchParams.get("page"));

  useEffect(() => {
    setLoading(true);
    (async function () {
      try {
        let uri = `/api/atab/common-account?CompanyProfileId=2&limit=${limit}&skip=${limit * page}`;
        if (startDate && endDate) {
          uri += `&start_date=${startDate.toISOString().split("T")[0]}&end_date=${
            endDate.toISOString().split("T")[0]
          }`;
        }
        const res: any = await HttpClient.get(uri);
        if (res.success) {
          setAllAccount(res.data);
          setLoading(false);
          setTotal(res.total);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    })();
  }, [page, limit, endDate, startDate, refresh]);

  const handlePageChange = (_event: any, newPage: number): void => {
    searchParams.set("page", newPage.toString());
    setSearchParams(searchParams);
  };
  // const handleStatus = (e: SelectChangeEvent<string>) => {
  //   searchParams.set("status", e.target.value);
  //   setSearchParams(searchParams);
  // };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  // const paginatedInvoice = applyPagination(allAccount, page, limit);

  const handelInputChange = debounce((value: string, key: string) => {
    setFilterItem((prevState: any) => ({
      ...prevState,
      [key]: value,
    }));
  }, 2000);
  return (
    <Container sx={{ mt: 4 }} maxWidth="xl">
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={3}
      >
        <Grid item xs={12}>
          <Card>
            <CardHeader
              action={
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 1,
                  }}
                >
                  {/* <TextField
                    label="Search by money receipt no"
                    id="standard-search"
                    type="search"
                    size="small"
                    variant="outlined"
                    onChange={
                      (e: React.ChangeEvent<HTMLInputElement>) =>
                        handelInputChange(e.target.value, "receipt_no")
                      // setSearchInvoiceVal(e.target.value)
                    }
                  /> */}

                  {/* <Grid
                    item
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <DatePicker
                      label="Start Date"
                      value={startDate}
                      onChange={(e: any) => setStartDate(e)}
                    />
                  </Grid>
                  <Grid
                    item
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Typography
                      fontWeight={"bold"}
                      variant="h6"
                      component="h6"
                      gutterBottom
                    >
                      To
                    </Typography>

                    <DatePicker
                      label="End Date"
                      value={endDate}
                      onChange={(e: any) => setEndDate(e)}
                    />
                  </Grid> */}

                  {/* <Button onClick={() => setOpen(true)} variant="contained">
                    Create Account
                  </Button> */}
                </Box>
              }
              title="Account List"
            />
            <Divider />

            <CardContent>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Account Name</TableCell>
                      <TableCell>Account Number</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Bank Name</TableCell>
                      <TableCell>Branch Name</TableCell>
                      <TableCell>Balance</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableLoader />
                    ) : allAccount.length ? (
                      <>
                        {allAccount.map((item) => (
                          <TraineeAccountTableRow
                            key={item.id}
                            accountData={item}
                            setAllAccount={setAllAccount}
                            allAccount={allAccount}
                          />
                        ))}
                      </>
                    ) : (
                      <TableNotFound />
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box p={2}>
                <TablePagination
                  component="div"
                  count={total}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleLimitChange}
                  page={page && page}
                  rowsPerPage={limit}
                  rowsPerPageOptions={[25, 50, 75, 100]}
                />
              </Box>
            </CardContent>

            {/* Modal */}
            <ModalsWrapper
              modalData={{ title: "Create Account" }}
              setShowModal={setOpen}
              showModal={open}
            >
              <CreateTraineeAccount
                setRefresh={setRefresh}
                handelClose={() => setOpen(false)}
              />
            </ModalsWrapper>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default TraineeAccountList;
